// extracted by css-extract-rspack-plugin
export default {"container":"container-a45eY0"};